/**
 *
 *
 *
 *
 *
 *
 */
export const waitForNextAnimationFrame = (): Promise<number> =>
  new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));
